export enum DateFormatType {
  SERVER_DATE_TIME = 'LL',
  LOCAL_DATE = 'LLL',
  LOCAL_DATE_TIME = 'LLLL',
}
